/**
 * @GENERATED from Figma node 3638:51877
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GongBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#8039E9"
      d="M21.509 10.405h-5.872a.508.508 0 0 0-.472.674l1.415 3.718a.246.246 0 0 1-.24.332l-1.806-.113a.23.23 0 0 0-.207.105l-1.406 2.021a.243.243 0 0 1-.344.073L10.5 15.78a.24.24 0 0 0-.272 0l-2.876 1.98c-.184.13-.431-.049-.367-.268l.798-2.914a.24.24 0 0 0-.143-.292l-1.526-.633a.245.245 0 0 1-.096-.381l1.35-1.689a.25.25 0 0 0 .008-.292L6.242 9.626a.244.244 0 0 1 .183-.381l1.758-.138a.244.244 0 0 0 .224-.26l-.136-2.5a.247.247 0 0 1 .335-.244l2.181.918a.23.23 0 0 0 .272-.065l1.502-1.705a.244.244 0 0 1 .407.065l.903 2.362c.12.292.48.398.735.203l3.531-2.67c.4-.3.144-.95-.351-.877l-2.325.316a.24.24 0 0 1-.256-.154l-1.222-3.19a.475.475 0 0 0-.799-.146l-2.66 2.93a.24.24 0 0 1-.272.057l-3.5-1.501a.486.486 0 0 0-.67.438l-.128 3.669a.244.244 0 0 1-.224.235L2.535 7.2a.49.49 0 0 0-.368.763l2.125 3.182a.25.25 0 0 1-.016.3L2.12 13.96a.49.49 0 0 0 .176.772l2.477 1.087a.24.24 0 0 1 .135.284l-1.581 6.283c-.112.446.383.787.75.52l5.944-4.335a.24.24 0 0 1 .28 0l2.708 1.932a.476.476 0 0 0 .68-.13l1.693-2.638a.225.225 0 0 1 .232-.106l4.05.495c.328.05.655-.227.535-.535l-1.685-4.432c-.048-.122 0-.252.144-.325l3.075-1.477c.456-.235.296-.95-.223-.95"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GongBright);
export { ForwardRef as GongBright };
